export const dialogNames = {
  codePushChannel: 'codePushChannel',
  codePushProgress: 'codePushProgress',
  env: 'env',
  error: 'error',
  systemAdmin: 'systemAdmin',
  customerCount: 'customerCount',
  accountPermission: 'accountPermission',
};
